import React, { useContext } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

const Sidebar = () => {
  const location = useLocation();
  const { logout } = useContext(AuthContext);

  const navItems = [
    { path: '/dashboard', label: 'Dashboard', color: 'bg-blue-600' },
    { path: '/evaluate/sample-order/auto', label: 'Auto Evaluation', color: 'bg-green-300' },
    { path: '/evaluate/sample-order/manual', label: 'Manual Evaluation', color: 'bg-green-400' },
    { path: '/evaluate/sample-order/approve', label: 'Evaluation Approver Page', color: 'bg-green-500' },
    { path: '/payouts', label: 'Payout Approver Page', color: 'bg-purple-500' },
    { path: '/orders/all', label: 'All Orders', color: 'bg-orange-500' },
  ];

  const handleLogout = () => {
    console.log('[Sidebar] handleLogout triggered...');
    logout();
    console.log('[Sidebar] Logout process initiated.');
  };

  return (
    <aside className="w-64 bg-white border-r-2 border-gray-300 min-h-screen p-4">
      <div className="text-2xl font-semibold mb-6 text-gray-800">Evaluator Panel</div>
      <nav>
        {navItems.map((item) => {
          const isActive = location.pathname === item.path;

          const baseClasses = 'block py-2 px-3 rounded mb-2 text-white';
          const activeClasses = isActive ? `bg-gray-700` : item.color;

          return (
            <Link
              key={item.path}
              to={item.path}
              className={`${baseClasses} ${activeClasses}`}
            >
              {item.label}
            </Link>
          );
        })}

        {/* Logout Button */}
        <button
          onClick={handleLogout}
          className="block w-full text-left py-2 px-3 rounded hover:bg-gray-300 mt-4 text-gray-800"
        >
          Logout
        </button>
      </nav>
    </aside>
  );
};

export default Sidebar;
